<div class="card">
	<p-dataView
		#dv
		layout="grid"
		[value]="medias"
		[paginator]="false"
		[rows]="12"
		filterBy="name"
		[sortField]="sortField"
		[sortOrder]="sortOrder"
	>
		<ng-template pTemplate="header">
			<section
				class="media-header"
				aria-label="Filtros y acciones de la biblioteca multimedia"
			>
				<!-- Encabezado principal -->
				<div class="media-header__top">
					<div class="media-header__title">
						<div class="media-header__icon">
							<i class="pi pi-images"></i>
						</div>

						<div>
							<h2>Biblioteca multimedia</h2>
							<p>
								Administre, filtre y consulte los contenidos
								multimedia.
							</p>
						</div>
					</div>

					<div class="media-header__summary">
						<i class="pi pi-folder"></i>
						<span>
							<strong>{{ paginationData?.total || 0 }}</strong>
							archivos
						</span>
					</div>
				</div>

				<!-- Selección de estructura administrativa -->
				<div
					class="media-header__context"
					*ngIf="
						isAdmin ||
						(selectedClientId && companias.length > 0) ||
						(selectedCompaniaId && media_clients.length > 0)
					"
				>
					<div class="section-label">
						<i class="pi pi-sitemap"></i>
						<span>Ubicación del contenido</span>
					</div>

					<div class="context-grid">
						<div class="filter-field" *ngIf="isAdmin">
							<label for="clientFilter">Cliente o partner</label>

							<p-dropdown
								inputId="clientFilter"
								[options]="clientes"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedClientId"
								(ngModelChange)="onClientChange()"
								[filter]="true"
								[showClear]="true"
								styleClass="filter-dropdown"
								placeholder="Todos los clientes"
								emptyFilterMessage="No se encontraron resultados"
							></p-dropdown>
						</div>

						<div
							class="filter-field"
							*ngIf="selectedClientId && companias.length > 0"
						>
							<label for="companyFilter">Compañía</label>

							<p-dropdown
								inputId="companyFilter"
								[options]="companias"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedCompaniaId"
								(ngModelChange)="onCompanyChange()"
								[filter]="true"
								[showClear]="true"
								styleClass="filter-dropdown"
								placeholder="Todas las compañías"
								emptyFilterMessage="No se encontraron resultados"
							></p-dropdown>
						</div>

						<div
							class="filter-field"
							*ngIf="
								selectedCompaniaId && media_clients.length > 0
							"
						>
							<label for="mediaClientFilter"
								>Partner multimedia</label
							>

							<p-dropdown
								inputId="mediaClientFilter"
								[options]="media_clients"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedMediaClientId"
								[filter]="true"
								[showClear]="true"
								styleClass="filter-dropdown"
								placeholder="Todos los partners"
								emptyFilterMessage="No se encontraron resultados"
							></p-dropdown>
						</div>
					</div>
				</div>

				<!-- Filtros principales -->
				<div class="media-header__filters">
					<div class="section-label">
						<i class="pi pi-filter"></i>
						<span>Filtros de búsqueda</span>
					</div>

					<div class="filters-grid">
						<div class="filter-field filter-field--search">
							<label for="mediaSearch">Buscar contenido</label>

							<div class="search-control">
								<i class="pi pi-search"></i>

								<input
									id="mediaSearch"
									type="text"
									pInputText
									[(ngModel)]="searchName"
									placeholder="Nombre del archivo multimedia"
									(keydown.enter)="applyFilters()"
								/>
							</div>
						</div>

						<div class="filter-field">
							<label for="categoryFilter">Categoría</label>

							<p-dropdown
								inputId="categoryFilter"
								[options]="categories"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedCategoryId"
								[filter]="true"
								[showClear]="true"
								styleClass="filter-dropdown"
								placeholder="Todas las categorías"
								emptyFilterMessage="No se encontraron resultados"
							></p-dropdown>
						</div>

						<div class="validity-filter">
							<div class="validity-filter__text">
								<span>Contenido vigente</span>
								<small>Ocultar elementos vencidos</small>
							</div>

							<p-inputSwitch
								[(ngModel)]="validity"
								(ngModelChange)="applyFilters()"
								inputId="validityFilter"
							></p-inputSwitch>
						</div>

						<div class="filter-actions">
							<button
								pButton
								type="button"
								label="Limpiar"
								icon="pi pi-times"
								class="p-button-outlined p-button-secondary"
								(click)="clearFilters()"
								pTooltip="Restablecer todos los filtros"
								tooltipPosition="top"
							></button>

							<button
								pButton
								type="button"
								label="Buscar"
								icon="pi pi-search"
								class="p-button-primary"
								(click)="applyFilters()"
								[disabled]="
									!searchName?.trim() &&
									!selectedCategoryId &&
									!selectedClientId &&
									!selectedCompaniaId &&
									!selectedMediaClientId
								"
							></button>
						</div>
					</div>
				</div>

				<!-- Acciones de administración -->
				<div class="media-header__actions" *ngIf="canAddMedia">
					<div class="section-label section-label--actions">
						<i class="pi pi-cog"></i>
						<span>Acciones</span>
					</div>

					<div class="actions-group">
						<button
							pButton
							type="button"
							label="Reporte KPI"
							icon="pi pi-chart-bar"
							class="p-button-outlined p-button-help"
							(click)="makeKpi()"
						></button>

						<button
							pButton
							type="button"
							label="Agregar contenido"
							icon="pi pi-plus"
							class="p-button-success"
							(click)="openModal()"
						></button>
					</div>
				</div>
			</section>
		</ng-template>
		<ng-template let-media pTemplate="listItem">
			<div class="p-col-12">
				<div class="product-list-item grid">
					<div class="col-3 list-container-image">
						<p-image
							[preview]="true"
							*ngIf="media.type === 'IMAGE'"
							src="{{ media.resource_url }}"
						></p-image>
						<img
							*ngIf="media.type === 'VIDEO'"
							class="thumb-video"
							(click)="openVideo(media)"
							src="{{ media.thumb_url }}"
						/>
					</div>
					<div class="col-6 product-list-detail">
						<div class="product-name">{{ media.name }}</div>
						<div class="product-description">
							{{ media.description }}
						</div>
						<div class="total-views-monthly" *ngIf="isAdmin">
							<i
								class="pi pi-eye"
								pTooltip="Reproducciones totales"
								tooltipPosition="top"
							></i>
							{{
								media.total_views?.total
									? +media.total_views.total
									: 0
							}}
						</div>
					</div>
					<div class="col-3 product-list-action">
						<!-- <button pButton type="button" icon="pi pi-download" (click)="exportMedia(media)" class="p-button-rounded p-button-success"></button> -->
						<button
							pButton
							type="button"
							icon="pi pi-times"
							(click)="deleteMedia(media)"
							class="p-button-rounded p-button-danger"
						></button>
						<button
							pButton
							type="button"
							icon="pi pi-pencil"
							(click)="editMedia(media)"
							class="p-button-sm p-button-rounded p-button-info mx-1"
							pTooltip="Editar"
						></button>
					</div>
					<div class="media-categories mt-2">
						<span
							*ngFor="let cat of media.categories"
							class="p-tag p-tag-rounded p-mr-1 p-mb-1"
						>
							{{ cat.name }}
						</span>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template let-media pTemplate="gridItem">
			<div
				class="p-col-12 p-med-2 p-lg-2"
				(click)="toggleExpand(media.id)"
			>
				<div
					class="product-grid-item card"
					[ngClass]="{ 'expanded-card': hoveredCard === media.id }"
				>
					<div class="cliente-asociado text-center">
						<strong>{{ getClientName(media.client_id) }}</strong>
					</div>
					<div class="product-grid-item-content">
						<p-image
							[preview]="true"
							*ngIf="media.type === 'IMAGE'"
							class="grid-image"
							[src]="media.resource_url"
						></p-image>
						<img
							*ngIf="media.type === 'VIDEO'"
							class="thumb-video"
							(click)="openVideo(media)"
							[src]="media.thumb_url"
						/>
						<div class="product-name">{{ media.name }}</div>
						<!-- <div class="total-views-monthly" *ngIf="isAdmin">
							<i
								class="pi pi-eye"
								pTooltip="Reproducciones totales"
								tooltipPosition="top"
							></i>
							{{
								media.total_views?.total
									? +media.total_views.total
									: 0
							}}
						</div> -->
					</div>
					<div
						*ngIf="hoveredCard === media.id"
						class="product-grid-item-bottom"
					>
						<!-- <button
						pButton
						type="button"
						icon="pi pi-download"
						(click)="exportMedia(media)"
						class="p-button-sm p-button-rounded p-button-success mx-1"
					></button> -->
						<button
							pButton
							type="button"
							icon="pi pi-times"
							(click)="deleteMedia(media)"
							class="p-button-sm p-button-rounded p-button-danger mx-1"
						></button>
						<button
							pButton
							type="button"
							icon="pi pi-pencil"
							(click)="editMedia(media)"
							class="p-button-sm p-button-rounded p-button-info mx-1"
							pTooltip="Editar"
						></button>
					</div>
					<div class="vigencia-status text-center mt-2 mb-2">
						<span
							class="p-tag p-tag-rounded"
							[ngClass]="
								!media.vigencia
									? 'p-tag-warning'
									: isCurrent(media)
										? 'p-tag-success'
										: 'p-tag-danger'
							"
						>
							{{
								!media.vigencia
									? "Sin fecha de vencimiento"
									: formatDate(media.vigencia)
							}}
						</span>
					</div>
					<div
						class="media-categories mt-2 category-preview"
						[ngClass]="{ expanded: hoveredCard === media.id }"
					>
						<ng-container *ngIf="hoveredCard === media.id">
							<div class="category-title">Categorías</div>
							<span
								*ngFor="let cat of media.categories"
								class="p-tag p-tag-rounded p-mr-1 p-mb-1"
							>
								{{ cat.name }}
							</span>
						</ng-container>
						<ng-container *ngIf="hoveredCard !== media.id">
							<div class="category-title">Categorías</div>
							<span class="p-tag p-tag-rounded p-mr-1 p-mb-1">
								{{ media.categories[0]?.name }}
							</span>
							<span
								*ngIf="media.categories.length > 1"
								class="p-tag p-tag-rounded p-mr-1 p-mb-1 p-tag-info"
							>
								+{{ media.categories.length - 1 }}
							</span>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>

	<p-paginator
		[first]="(currentPage - 1) * rows"
		[rows]="rows"
		[totalRecords]="paginationData.total"
		[pageLinkSize]="5"
		(onPageChange)="getMedias($event)"
	></p-paginator>
</div>
